import React from "react";
import { HighlightMenu, MenuButton } from "react-highlight-menu";
import { Message, MessageDropdownState } from "../types";
import { MessageBubble } from "./MessageBubble";

interface MessageListProps {
  messages: Message[];
  messagesListRef: React.RefObject<HTMLDivElement>;
  latestMessageRef: React.RefObject<HTMLDivElement>;
  isMessageIncoming: boolean;
  botTypingMsg: string | null | undefined;
  userHasCommentPermission: boolean;
  queryType: string | null | undefined;
  messageDropdown: MessageDropdownState;
  onDropdownToggle: (messageId: number, event: React.MouseEvent) => void;
  onDropdownClick: (action: string, messageId: number) => void;
  onEnlargeImage: (url: string) => void;
  onOpenDocument: (doc: string) => void;
  onSearchInSuborg: (selectedText: string) => void;
  onCitationClick: (url: string) => void;
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  messagesListRef,
  latestMessageRef,
  isMessageIncoming,
  botTypingMsg,
  userHasCommentPermission,
  queryType,
  messageDropdown,
  onDropdownToggle,
  onDropdownClick,
  onEnlargeImage,
  onOpenDocument,
  onSearchInSuborg,
  onCitationClick,
}) => {
  return (
    <div
      className="flex-1 px-3 overflow-y-auto overflow-x-hidden max-h-screen"
      ref={messagesListRef}
    >
      <HighlightMenu
        target={messagesListRef}
        allowedPlacements={["top", "bottom"]}
        menu={({ selectedText = "", setClipboard, setMenuOpen }) => (
          <>
            <MenuButton
              title="Copy to clipboard"
              style={{ backgroundColor: "#fff", color: "#000" }}
              onClick={() => {
                setClipboard(selectedText);
                setMenuOpen(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                />
              </svg>
            </MenuButton>
            <MenuButton
              title="Search in another document set"
              style={{ backgroundColor: "#fff", color: "#000" }}
              onClick={() => {
                onSearchInSuborg(selectedText);
                setMenuOpen(false);
              }}
              icon="magnifying-glass"
            />
          </>
        )}
      />
      {messages.map((message, index) => (
        <MessageBubble
          key={message.id}
          message={message}
          isLast={index === messages.length - 1}
          isMessageIncoming={isMessageIncoming}
          botTypingMsg={botTypingMsg}
          userHasCommentPermission={userHasCommentPermission}
          queryType={queryType}
          messageDropdown={messageDropdown}
          latestMessageRef={latestMessageRef}
          onDropdownToggle={onDropdownToggle}
          onDropdownClick={onDropdownClick}
          onEnlargeImage={onEnlargeImage}
          onOpenDocument={onOpenDocument}
          onCitationClick={onCitationClick}
        />
      ))}
    </div>
  );
};
